var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1263 1263",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-561.2,-202.548)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,35.9757,-112.936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1003.89,1559.7C729.075,1491.33 525.224,1242.75 525.224,946.936C525.224,598.428 808.169,315.484 1156.68,315.484C1477.3,315.484 1742.44,554.968 1782.79,864.676L1523.51,602.767L1156.68,574.362L1045.91,809.086L1076.02,1018.64L782.636,1336.2L1003.89,1559.7Z",
    style: {
      fill: "rgb(157,120,255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.07374,-1.06296,0.952627,0.962291,-889.876,2175.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1247.02,620.145L1247.02,387.884L1532.88,373.654L1616.3,248.026L1777.69,182.382L1937.01,387.884L1937.01,660.056C1926.14,676.018 1914.2,691.371 1901.22,706.004C1738.94,888.914 1474.11,890.405 1310.18,709.332C1285.4,681.954 1264.33,651.96 1247.02,620.145Z",
    style: {
      fill: "rgb(125,92,214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.961531,0,0,0.964131,48.6357,147.815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1057.41,745.903C1023.65,695.385 1004,634.931 1004,570C1004,392.835 1150.3,249 1330.5,249C1510.7,249 1657,392.835 1657,570C1657,747.165 1510.7,891 1330.5,891C1266.46,891 1206.7,872.832 1156.26,841.454L865.924,1130.96C852.156,1144.69 829.832,1144.65 816.103,1130.89C816.103,1130.89 768.795,1083.44 768.795,1083.44C755.066,1069.67 755.098,1047.35 768.866,1033.62L1057.41,745.903ZM1330.5,350.717C1453.6,350.717 1553.54,448.974 1553.54,570C1553.54,691.026 1453.6,789.283 1330.5,789.283C1207.4,789.283 1107.46,691.026 1107.46,570C1107.46,448.974 1207.4,350.717 1330.5,350.717Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.02483,-0.251557,0.0711235,0.289754,-51.7715,962.743)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1112,
    y: 773.177,
    width: 397.006,
    height: 82.107,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.18311,-0.290407,0.0961378,0.391662,-308.054,868.849)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1112,
    y: 773.177,
    width: 397.006,
    height: 82.107,
    style: {
      fill: "white"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.7c9229ef2e13ff4bf4fd860445fe9351.svg";
export { ForwardRef as ReactComponent };